import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    CustomerDetailsList: [],
};

const customerSlice = createSlice({
  name: "buildingSlice",
  initialState,
  reducers: {
    CustomerDetailsListAction: (state, action) => {
      state.CustomerDetailsList = action.payload.CustomerDetailsList;
    },
    resetStateCustomerAction: () => initialState,
  },
});

export const {
    CustomerDetailsListAction,
    resetStateCustomerAction
} = customerSlice.actions;

export default customerSlice.reducer;
